<template>
  <div>
    <TheAppLogo
      class="mb-2 mb-md-8"
    />
    <v-navigation-drawer
      floating
      v-model="drawer"
      width="100%"
      class="transparent"
    >
      <v-list
        nav
        class="pa-0"
      >
        <v-list-item
          v-for="(item, key) in menuList"
          :key="key"
          link
          class="brand-primary--text text--tone-400 text-heading-m py-3 pl-4 pr-6 no-min-height"
          :to="item.link"
        >
          <v-list-item-icon class="align-center mr-2 my-0 align-self-center">
            <font-awesome-icon :icon="item.icon" size="lg" />
          </v-list-item-icon>

          <v-list-item-content class="pa-0">
            {{ item.title }}
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
  </div>
</template>

<script>
import TheAppLogo from '@/views/containers/TheAppLogo.vue';

export default {
  components: {
    TheAppLogo,
  },
  data() {
    return {
      drawer: true,
      menuList: [
        {
          title: 'Cours disponibles',
          icon: 'fa-regular fa-list',
          link: '/courses',
        },
        {
          title: 'Mes cours',
          icon: 'fa-regular fa-backpack',
          link: '/subscriptions',
        },
        {
          title: 'Mon profil',
          icon: 'fa-regular fa-user',
          link: '/profile',
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.v-list-item.v-list-item--active {
  border-radius: 4px;
  background-color: var(--v-brand-primary-tone-400);
  color: white!important;
}

.no-min-height {
  min-height: 0px!important;
}
</style>
